import { clsx as a } from "../bundled_deps/.pnpm/clsx@2.1.1/bundled_deps/clsx/dist/clsx.js";
import { extendTailwindMerge as o } from "../bundled_deps/.pnpm/tailwind-merge@2.5.4/bundled_deps/tailwind-merge/dist/bundle-mjs.js";
import { defaultConfig as i } from "../bundled_deps/.pnpm/tailwind-variants@0.3.1_tailwindcss@3.4.17/bundled_deps/tailwind-variants/dist/index.js";
const x = ["text-h1", "text-h2", "text-h3", "text-base", "text-base-bold", "text-support", "text-support-bold", "text-caption", "text-caption-bold", "text-editorial-h1", "text-editorial-h2", "text-editorial-h3", "text-editorial-subtitle-1", "text-editorial-subtitle-2", "text-editorial-body", "text-data-h1", "text-data-h2", "text-data-h3", "text-data-h4", "text-data-h5", "text-data-body", "text-data-caption", "text-data-detail"], t = {
  extend: {
    classGroups: {
      "intercom-typography": x
    }
  }
}, d = o(t);
i.twMergeConfig = t;
function p(...e) {
  return d(a(e));
}
export {
  p as cn
};
